import React, { Component } from 'react';
import { Repeater, ItemContainer } from '../../../../library/repeater';
import Switch, { Case } from '../../../../library/ReactSwitchCase';
import PostListInjector from '../../../../library/board/PostListInjector';
import * as BoardAction from '../../../../library/board/BoardAction';
import Paging from '../../../common/components/Paging';

import NoticeListItem from './NoticeListItem';
import { routes } from '../../../../constants/routes';

class NoticeListContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openPostId: 0,
      isLoading: false,
    };
    this.changeOpenPostId = this.changeOpenPostId.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
  }

  onChangePage(pageno) {
    let query = { ...this.props.history.query, pageno };
    this.props.getPostList(query);
    this.props.history.push(`${routes.customer.notice}?pageno=${pageno}`);
  }

  changeOpenPostId(postId) {
    if (this.state.openPostId !== postId) {
      this.setState({ openPostId: postId });
    }
  }

  componentWillUnmount() {
    this.props.initPostDetail();
  }

  render() {
    const { postList, pageSize } = this.props;
    const { pageno = 1 } = this.props.history.query;
    const counts = postList && postList.count ? postList.count : 0;
    return (
      <div id="contents" className="notice-list">
        <h3>공지사항</h3>
        {postList.results.length > 0 && (
          <Repeater
            arrayData={postList.results}
            propName="targetPostInfo"
            elementName="ul"
            className="list-type accordion"
          >
            <ItemContainer>
              <NoticeListItem
                {...this.props}
                changeOpenPostId={this.changeOpenPostId}
                openPostId={this.state.openPostId}
              />
            </ItemContainer>
          </Repeater>
        )}
        <Switch condition={postList.results.length}>
          <Case value={0}>
            <div className="message-box no-data">
              <p>
                <strong>등록된 글이 없습니다.</strong>
              </p>
            </div>
          </Case>
        </Switch>
        {postList && postList.results && postList.count !== 0 && (
          <Paging
            selected={parseInt(pageno, 10)}
            step={5}
            onClick={this.onChangePage}
            count={counts}
            pageSize={pageSize}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    postInfo: state.BoardReducer.postInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { boardType, boardName } = ownProps;
  return {
    getPostInfo: (postId) => {
      dispatch(BoardAction.getPostInfo(boardType, boardName, postId));
    },
    initPostDetail: () => {
      dispatch(BoardAction.initPostDetail());
    },
  };
};

export default PostListInjector(
  mapStateToProps,
  mapDispatchToProps
)(NoticeListContainer);
